module.exports = __webpack_public_path__ + "static/media/0023_IMG_LE_SOL_MEGALITH_MEGABLACK.cc714723.png";